import React from "react";
import "../../../css/Views/InvoiceDocumentForm.css";

const InvoiceDocumentForm = ({
    form,
    onChange,
    validationErrors,
    isPaymentManuallyConfirmed,
    paymentManuallyConfirmedByUserName,
    paymentManuallyConfirmedAt,
    isChangingPaymentConfirmation,
    onPaymentConfirmationChange
}) => {
    const updateField = (field, value) => {
        onChange({
            ...form,
            [field]: value
        });
    };

    return (
        <div className="invoice-document-form">

            <div className="invoice-form-special-options">

                <div className={`invoice-ignore-toggle ${form.isIgnored ? "invoice-ignore-toggle-active" : ""}`} onClick={() => updateField("isIgnored", !form.isIgnored)}>
                    <div className="invoice-ignore-checkbox">
                        {form.isIgnored ? "✓" : ""}
                    </div>

                    <span>
                        Ignoruj dokument
                    </span>
                </div>

                <div className={`invoice-konekto-toggle ${form.isUploadedToKonektoSmart ? "invoice-konekto-toggle-active" : ""}`} onClick={() => updateField("isUploadedToKonektoSmart", !form.isUploadedToKonektoSmart)}>
                    <div className="invoice-konekto-checkbox">
                        {form.isUploadedToKonektoSmart ? "✓" : ""}
                    </div>

                    <span>
                        Wczytana w Konekto
                    </span>
                </div>

            </div>

            {!form.isIgnored && (
                <>
                    <div className="invoice-form-grid">

                        <div className="invoice-form-field">
                            <label>
                                Data wystawienia *
                            </label>

                            <input type="date" value={form.issueDate} onChange={(e) => updateField("issueDate", e.target.value)} />

                            {validationErrors.issueDate && (
                                <div className="invoice-form-error">
                                    {validationErrors.issueDate}
                                </div>
                            )}
                        </div>

                        <div className="invoice-form-field">
                            <label>
                                Kontrahent *
                            </label>

                            <input type="text" value={form.contractor} onChange={(e) => updateField("contractor", e.target.value)} />

                            {validationErrors.contractor && (
                                <div className="invoice-form-error">
                                    {validationErrors.contractor}
                                </div>
                            )}
                        </div>

                        <div className="invoice-form-field">
                            <label>
                                NIP kontrahenta
                            </label>

                            <input type="text" inputMode="numeric" maxLength={10} value={form.contractorNip} onChange={(e) => updateField("contractorNip", e.target.value)} placeholder="Np. 1234567890" />
                        </div>

                        <div className="invoice-form-field">
                            <label>
                                Numer dokumentu *
                            </label>

                            <input type="text" value={form.documentNumber} onChange={(e) => updateField("documentNumber", e.target.value)} />

                            {validationErrors.documentNumber && (
                                <div className="invoice-form-error">
                                    {validationErrors.documentNumber}
                                </div>
                            )}
                        </div>

                        <div className="invoice-form-field">
                            <label>
                                Numer KSeF
                            </label>

                            <input type="text" maxLength={64} value={form.ksefNumber} onChange={(e) => updateField("ksefNumber", e.target.value)} />
                        </div>

                        <div className="invoice-form-field">
                            <label>
                                Wartość brutto *
                            </label>

                            <input type="number" step="0.01" min="0" value={form.grossAmount ?? ""} onChange={(e) => updateField("grossAmount", e.target.value === "" ? null : Number(e.target.value))} />

                            {validationErrors.grossAmount && (
                                <div className="invoice-form-error">
                                    {validationErrors.grossAmount}
                                </div>
                            )}
                        </div>

                        <div className="invoice-form-field">
                            <label>
                                Waluta
                            </label>

                            <input type="text" value={form.currency} onChange={(e) => updateField("currency", e.target.value)} />
                        </div>

                    </div>

                    <div className="invoice-form-field invoice-form-notes">
                        <label>
                            Uwagi
                        </label>

                        <textarea value={form.notes} onChange={(e) => updateField("notes", e.target.value)} rows={2} />
                    </div>

                    <div className="invoice-payment-section">

                        <div className="invoice-payment-section-info">
                            <div className="invoice-payment-section-title">
                                Płatność
                            </div>

                            {isPaymentManuallyConfirmed ? (
                                <div className="invoice-payment-confirmation-info">
                                    Oznaczona ręcznie jako opłacona

                                    {paymentManuallyConfirmedByUserName && (
                                        <>
                                            {" · "}
                                            {paymentManuallyConfirmedByUserName}
                                        </>
                                    )}

                                    {paymentManuallyConfirmedAt && (
                                        <>
                                            {" · "}
                                            {new Date(paymentManuallyConfirmedAt).toLocaleString("pl-PL")}
                                        </>
                                    )}
                                </div>
                            ) : (
                                <div className="invoice-payment-section-description">
                                    Możesz ręcznie oznaczyć dokument jako opłacony niezależnie od powiązanych przelewów.
                                </div>
                            )}
                        </div>

                        <button type="button" className={`invoice-payment-action ${isPaymentManuallyConfirmed ? "invoice-payment-action-confirmed" : ""} ${isChangingPaymentConfirmation ? "invoice-payment-action-disabled" : ""}`} onClick={() => {
                            if (!isChangingPaymentConfirmation)
                                onPaymentConfirmationChange(!isPaymentManuallyConfirmed);
                        }}>
                            {isChangingPaymentConfirmation
                                ? "Zapisywanie..."
                                : isPaymentManuallyConfirmed
                                    ? "Cofnij oznaczenie"
                                    : "Oznacz jako opłaconą"}
                        </button>

                    </div>
                </>
            )}

        </div>
    );
};

export default InvoiceDocumentForm;